import React from 'react';

const FormSection = ({ title, data, labels, getDate, handleDownload, withRefetchIcon = false, handleRefetchClick, formTypes }) => {
  if (!data?.length) return null;

  return (
    <>
      <div className='top-heading d-flex'>
        <h2>{title}</h2>
      </div>

      <div className='d-flex' style={{ marginBottom: '15px', position: 'relative' }}>
        <div className='d-flex role-detail-preview' style={{ gap: '30rem' }}>
          {data.map((ele, index) => (
            <div className='row' key={index} style={{ marginBottom: '5px' }}>
              <label className='col-sm-12' style={{ cursor: 'pointer' }}>
                {`${labels[index]} : `}
              {labels[index] && ele ? <a
                  href={() => false}
                  onClick={() => handleDownload(Array.isArray(formTypes) ? formTypes[index] : null, ele)}
                  title='Document'
                  rel='noopener noreferrer'
                >
                 {ele?.fileName ? ele?.fileName : `View (${getDate(ele)})`} 
                </a> : "-"}
              </label>
            </div>
          ))}
        </div>
        {withRefetchIcon ?<span onClick={handleRefetchClick} title='Generate CBI Onboarding Form' className='cbi_form_refetch'><i className="ic-refresh"></i></span>  : null}
      </div>
    </>
  );
};

export default FormSection;